import { PIPELINE_STATUS_OPTIONS } from 'constants/globalConstants';
import { $list as listSignal, $view as viewSignal } from 'signals/global.signals';
import displayError from 'utils/displayError';

export const handleClickStageHeader = (stageId, $view = viewSignal) => {
  const openStageCards = [...$view.value.openStageCards || []];
  if (openStageCards.includes(stageId)) {
    $view.update({
      openStageCards: openStageCards.filter((card) => card !== stageId),
    });
  } else {
    $view.update({
      openStageCards: [...openStageCards, stageId],
    });
  }
};

export const handleToggleExpandAllStageCards = (option = null, $view = viewSignal) => {
  if (option === 'expand') {
    return $view.update({
      openStageCards: PIPELINE_STATUS_OPTIONS.map((stage) => stage.id),
    });
  }

  if (option === 'collapse') {
    return $view.update({
      openStageCards: [],
    });
  }

  return $view.update({
    openStageCards: $view.value.openStageCards?.length > 0 ? [] : PIPELINE_STATUS_OPTIONS.map((stage) => stage.id),
  });
};

export const handleToggleView = (view, $view = viewSignal) => {
  if (view === $view.value.view) {
    return;
  }
  $view.update({
    view,
  });
};

export const handleDropItem = async ({
  droppedItem,
  droppedStageValue,
  updateCallback,
  $view = viewSignal,
  $list = listSignal,
}) => {
  $view.update({
    isDragDisabled: true,
  });
  const updatedPipelineItems = $list.value.data.map((item) => {
    if (item.id === droppedItem.id) {
      return {
        ...item,
        pipelineStatus: droppedStageValue,
      };
    }
    return item;
  });

  $list.update({
    ...$list.value,
    data: updatedPipelineItems,
  });
  try {
    await updateCallback(droppedItem.id, {
      pipelineStatus: droppedStageValue,
    });
  } catch (error) {
    displayError({
      message: 'Failed to update pipeline status. Changes have been reverted.',
      title: 'Update Error',
    });
  } finally {
    $view.update({
      isDragDisabled: false,
    });
  }
};
